import { render, staticRenderFns } from "./MC_InputItem_TD.vue?vue&type=template&id=354577ce&scoped=true"
import script from "./MC_InputItem_TD.vue?vue&type=script&lang=js"
export * from "./MC_InputItem_TD.vue?vue&type=script&lang=js"
import style0 from "./MC_InputItem_TD.vue?vue&type=style&index=0&id=354577ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354577ce",
  null
  
)

export default component.exports